import {Animated} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View``;

export const LimitTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ProgressBarContainer = styled.View`
  width: 100%;
  height: ${RFValue(22)}px;
  border-radius: ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  margin-top: ${RFValue(6)}px;

  padding: 2px 0px;
  border: 2px solid ${({theme}) => theme.colors.border};
`;

export const Progress = styled(Animated.View)`
  position: absolute;
  height: 100%;
  border-radius: ${RFValue(5.5)}px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin: 0 2px;

  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.blue};
`;

export const ProgressPercentage = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const LimitsTextContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${RFValue(6)}px;
`;

export const Limit = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
